import {
  DrawPreviewContainer,
  FilePreviewGrid,
  FilePreviewThumb,
  SignaturePreviewContainer,
} from 'pages/FieldNotebook/HistoricNoteSummary/styles';
import { useTranslation } from 'react-i18next';
import { formatTimestampDate } from 'utils/fieldNotebookUtils/formatters';
import { collapseLineBreaks } from 'utils/fieldNotebookUtils/collapseLineBreaks';
import { parseImageAnswer } from 'utils/fieldNotebookUtils/imageAnswer';
import { resolveFilePreview } from 'utils/fieldNotebookUtils/uploadPreviewCache';
import { Input } from '../Input/Input';

interface NoteSelectorProps {
  type: string | undefined;
  answer: string | undefined | null;
  // Histórico: exibe no máximo uma quebra de linha por vez
  isHistoric?: boolean;
}

export function NoteSelector({ type, answer, isHistoric }: NoteSelectorProps) {
  const { i18n, t } = useTranslation();
  const locale = i18n.language;

  if (!answer) {
    return (
      <Input color="#767676" weight={400}>
        {t('not_informed')}
      </Input>
    );
  }

  if (type === 'image') {
    const items = parseImageAnswer(answer);

    if (items.length === 0) {
      return (
        <Input color="#767676" weight={400}>
          {t('not_informed')}
        </Input>
      );
    }

    return (
      <FilePreviewGrid>
        {items.map((item, index) => {
          const preview = resolveFilePreview(item);

          if (preview.kind === 'image' && preview.src) {
            return (
              <FilePreviewThumb
                key={index}
                src={preview.src}
                alt={t('image_of_your_note')}
              />
            );
          }

          return (
            <Input key={index}>
              {preview.kind === 'pdf' ? t('attachedFile') : t('fileUploaded')}
            </Input>
          );
        })}
      </FilePreviewGrid>
    );
  }

  if (answer.includes('response-content-type=application%2Fpdf')) {
    return <Input>{t('attachedFile')}</Input>;
  }

  if (answer.includes('data:application/pdf')) {
    return <Input>{t('attachedFile')}</Input>;
  }

  switch (type) {
    case 'date':
      return <Input>{formatTimestampDate(answer, locale)}</Input>;
    case 'signature':
      return <SignaturePreviewContainer src={answer} />;
    case 'draw':
      return <DrawPreviewContainer src={answer} />;
    case 'checkbox_group':
      return (
        <Input>
          <strong>{answer}</strong>
        </Input>
      );
    default:
      return (
        <Input>{isHistoric ? collapseLineBreaks(answer) : answer}</Input>
      );
  }
}
